export default {
    init() {
        // JavaScript to be fired on the contact page
    },
    finalize() {
        $('.collapse').on('shown.bs.collapse', function () {
            $(this).find("iframe").attr("src", $(this).closest(".section-wrapper").data("map-url"));
            $(".bg-wrapper").css("background-image", "url('"+$(this).closest(".section-wrapper").data("image-url")+"')");
            $(".section-map-desktop iframe").attr("src", $(this).closest(".section-wrapper").data("map-url"));
        });
        $('.section-button').on("click", function() {
            if ($(window).width() >= 1024) {
                $(".collapse").collapse("hide");
            }
        });
        $('.section-button').first().trigger("click");
        $(".wpcf7-form-control").on("keyup", function() {
            if ($(this).val().length > 0) {
                $(this).closest(".group-input,.group-comment").find("label").show();
            } else {
                $(this).closest(".group-input,.group-comment").find("label").hide();
            }
        });
        $('#fake_file').change(function() {
            var file = $(this).get()[0].files[0];
            $(".group-fake-file").append("<span class='fake-file-info'>"+file.name+"</span>");
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/offer.js